// Traditional 54-card Mexican Lotería deck.
// Card names are the classic Don Clemente set (public domain).
// Emojis are approximations used for v1 tile art — swap for real card
// illustrations in a future iteration without changing the deck order.
export const LOTERIA_DECK = [
    { n: 1,  name: 'El Gallo',        en: 'The Rooster',   icon: '🐓' },
    { n: 2,  name: 'El Diablito',     en: 'The Little Devil', icon: '😈' },
    { n: 3,  name: 'La Dama',         en: 'The Lady',      icon: '💃' },
    { n: 4,  name: 'El Catrín',       en: 'The Dandy',     icon: '🎩' },
    { n: 5,  name: 'El Paraguas',     en: 'The Umbrella',  icon: '☂️' },
    { n: 6,  name: 'La Sirena',       en: 'The Mermaid',   icon: '🧜‍♀️' },
    { n: 7,  name: 'La Escalera',     en: 'The Ladder',    icon: '🪜' },
    { n: 8,  name: 'La Botella',      en: 'The Bottle',    icon: '🍾' },
    { n: 9,  name: 'El Barril',       en: 'The Barrel',    icon: '🛢️' },
    { n: 10, name: 'El Árbol',        en: 'The Tree',      icon: '🌳' },
    { n: 11, name: 'El Melón',        en: 'The Melon',     icon: '🍈' },
    { n: 12, name: 'El Valiente',     en: 'The Brave',     icon: '🗡️' },
    { n: 13, name: 'El Gorrito',      en: 'The Bonnet',    icon: '👒' },
    { n: 14, name: 'La Muerte',       en: 'The Death',     icon: '💀' },
    { n: 15, name: 'La Pera',         en: 'The Pear',      icon: '🍐' },
    { n: 16, name: 'La Bandera',      en: 'The Flag',      icon: '🇲🇽' },
    { n: 17, name: 'El Bandolón',     en: 'The Mandolin',  icon: '🪕' },
    { n: 18, name: 'El Violoncello',  en: 'The Cello',     icon: '🎻' },
    { n: 19, name: 'La Garza',        en: 'The Heron',     icon: '🦩' },
    { n: 20, name: 'El Pájaro',       en: 'The Bird',      icon: '🐦' },
    { n: 21, name: 'La Mano',         en: 'The Hand',      icon: '✋' },
    { n: 22, name: 'La Bota',         en: 'The Boot',      icon: '👢' },
    { n: 23, name: 'La Luna',         en: 'The Moon',      icon: '🌙' },
    { n: 24, name: 'El Cotorro',      en: 'The Parrot',    icon: '🦜' },
    { n: 25, name: 'El Borracho',     en: 'The Drunkard',  icon: '🍺' },
    { n: 26, name: 'El Negrito',      en: 'The Little Man', icon: '🧑🏾' },
    { n: 27, name: 'El Corazón',      en: 'The Heart',     icon: '❤️' },
    { n: 28, name: 'La Sandía',       en: 'The Watermelon', icon: '🍉' },
    { n: 29, name: 'El Tambor',       en: 'The Drum',      icon: '🥁' },
    { n: 30, name: 'El Camarón',      en: 'The Shrimp',    icon: '🦐' },
    { n: 31, name: 'Las Jaras',       en: 'The Arrows',    icon: '🏹' },
    { n: 32, name: 'El Músico',       en: 'The Musician',  icon: '🎺' },
    { n: 33, name: 'La Araña',        en: 'The Spider',    icon: '🕷️' },
    { n: 34, name: 'El Soldado',      en: 'The Soldier',   icon: '💂' },
    { n: 35, name: 'La Estrella',     en: 'The Star',      icon: '⭐' },
    { n: 36, name: 'El Cazo',         en: 'The Saucepan',  icon: '🥘' },
    { n: 37, name: 'El Mundo',        en: 'The World',     icon: '🌍' },
    { n: 38, name: 'El Apache',       en: 'The Apache',    icon: '🪶' },
    { n: 39, name: 'El Nopal',        en: 'The Cactus',    icon: '🌵' },
    { n: 40, name: 'El Alacrán',      en: 'The Scorpion',  icon: '🦂' },
    { n: 41, name: 'La Rosa',         en: 'The Rose',      icon: '🌹' },
    { n: 42, name: 'La Calavera',     en: 'The Skull',     icon: '☠️' },
    { n: 43, name: 'La Campana',      en: 'The Bell',      icon: '🔔' },
    { n: 44, name: 'El Cantarito',    en: 'The Water Pitcher', icon: '🏺' },
    { n: 45, name: 'El Venado',       en: 'The Deer',      icon: '🦌' },
    { n: 46, name: 'El Sol',          en: 'The Sun',       icon: '☀️' },
    { n: 47, name: 'La Corona',       en: 'The Crown',     icon: '👑' },
    { n: 48, name: 'La Chalupa',      en: 'The Canoe',     icon: '🛶' },
    { n: 49, name: 'El Pino',         en: 'The Pine Tree', icon: '🌲' },
    { n: 50, name: 'El Pescado',      en: 'The Fish',      icon: '🐟' },
    { n: 51, name: 'La Palma',        en: 'The Palm',      icon: '🌴' },
    { n: 52, name: 'La Maceta',       en: 'The Flowerpot', icon: '🪴' },
    { n: 53, name: 'El Arpa',         en: 'The Harp',      icon: '🎼' },
    { n: 54, name: 'La Rana',         en: 'The Frog',      icon: '🐸' },
];

/** Deterministic shuffle for a Fisher-Yates. Optionally accepts a seed. */
export function shuffleDeck(deck) {
    const out = [...deck];
    for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [out[i], out[j]] = [out[j], out[i]];
    }
    return out;
}

/** Build a random 4x4 tabla (16 unique cards) for a player. */
export function generateTabla() {
    return shuffleDeck(LOTERIA_DECK).slice(0, 16);
}
